/* eslint-disable */
// This file is auto gererated by build/build-entry.js
import JcImagesUpload from './images-upload/Index'//图片上传
import JcList from './list/Index'//列表加载
import Sku from './sku/Index'//商品规格
import TabBar from '../../pages/mall/TabBar'//tabbar
import BackTop from './back-top/Index'//一键置顶
import ShareLayer from './share-layer/Index'//分享图层

const version = '0.1.0'
const components = [
  JcImagesUpload,
  JcList,
  TabBar,
  BackTop,
  ShareLayer,
  Sku
]

const install = Vue => {
  components.forEach(Component => {
    Vue.component(Component.name, Component)
  })
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  version,
  JcImagesUpload,
  JcList,
  TabBar,
  BackTop,
  ShareLayer,
  Sku
}


// WEBPACK FOOTER //
// ./src/components/hzjc/index.js